<script>
import { storeToRefs } from 'pinia';
import { useVisitStore } from '../../../store/contact/VisitStore';

export default {
    setup() {
        const store = useVisitStore();
        const { setSelectedType, setSelectedEstate, setSelectedProperty } =
            store;
        const {
            estateList,
            officeTypes,
            residenceTypes,
            propertyList,
            selectedType,
            selectedEstate,
            selectedProperty,
            propertySelectionError,
        } = storeToRefs(store);
        return {
            estateList,
            officeTypes,
            residenceTypes,
            propertyList,
            selectedType,
            setSelectedType,
            selectedEstate,
            setSelectedEstate,
            selectedProperty,
            setSelectedProperty,
            propertySelectionError,
        };
    },
};
</script>
<template>
    <div id="formStep1">
        <div class="fs-24px tw-text-darkGreen mb-30px">
            What property are you interested in?
        </div>
        <form id="formStep1">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="form-group">
                        <label class="fs-16px fw-medium tw-text-black"
                            >Property type
                            <span class="tw-text-red">*</span></label
                        >
                        <select
                            name="propertyType"
                            @change="(e) => setSelectedType(e.target.value)"
                            v-model="selectedType"
                        >
                            <option value="Offices">Offices</option>
                            <option value="Residences">Residences</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div
                        :class="
                            (propertySelectionError['estate'] !== ''
                                ? 'tw-text-red'
                                : '') + ' form-group '
                        "
                    >
                        <label class="fs-16px fw-medium tw-text-black"
                            >Estate <span class="tw-text-red">*</span></label
                        >
                        <select
                            name="estate"
                            @change="(e) => setSelectedEstate(e.target.value)"
                            :style="
                                propertySelectionError['estate'] !== ''
                                    ? 'border-bottom: 1px solid red;'
                                    : ''
                            "
                            v-model="selectedEstate"
                        >
                            <option value="">Select an estate</option>
                            <option
                                :value="estates.id"
                                v-for="estates in estateList"
                            >
                                {{ estates.name }}
                            </option>
                        </select>
                        {{ propertySelectionError['estate'] }}
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div
                        :class="
                            (propertySelectionError['property'] !== ''
                                ? 'tw-text-red'
                                : '') + ' form-group '
                        "
                    >
                        <label class="fs-16px fw-medium tw-text-black"
                            >Property Name
                            <span class="tw-text-red">*</span></label
                        >
                        <select
                            name="propertyName"
                            @change="(e) => setSelectedProperty(e.target.value)"
                            :style="
                                propertySelectionError['property'] !== ''
                                    ? 'border-bottom: 1px solid red;'
                                    : ''
                            "
                            v-model="selectedProperty"
                        >
                            <option value="">Select a property</option>
                            <option
                                :value="property.id"
                                v-for="property in propertyList"
                                v-if="selectedEstate !== ''"
                            >
                                {{ property.name }}
                            </option>
                            <option
                                :value="property.id"
                                v-for="property in selectedType === 'Offices'
                                    ? officeTypes
                                    : residenceTypes"
                                v-else
                            >
                                {{ property.name }}
                            </option>
                        </select>
                        {{ propertySelectionError['property'] }}
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script></script>
